import React from "react";
import { Item } from "../style";
import { Body, TextDisplay } from "components/parts/Typography";
import HoverUnderline from "components/parts/HoverUnderline";
import { Caret } from "../../Caret";
import type { AppTheme } from "themes/global";
import type { NavLinkProps } from "../navigation-links";
import { useNavigation } from "../NavigationContext";

// Helper function to detect touch devices
export const isTouchDevice = () =>
  typeof window !== "undefined" && "ontouchstart" in document.documentElement;

interface MenuItemWithDropdownProps {
  item: NavLinkProps;
  theme: AppTheme;
}

export const MenuItemWithDropdown = ({
  item,
  theme
}: MenuItemWithDropdownProps) => {
  const isTouch = isTouchDevice();
  const { activeMenu, setActiveMenu } = useNavigation();
  const isActive = activeMenu === item.key;

  return (
    <Item
      data-name={item.key}
      theme={theme}
      onMouseEnter={!isTouch ? () => setActiveMenu(item.key) : undefined}
    >
      <button
        className="flex border-0 bg-black"
        onClick={() => setActiveMenu(isActive ? null : item.key)}
        aria-expanded={isActive}
      >
        <Body
          size="sm"
          m="0"
          semiBold
          lg={{ display: TextDisplay.inline }}
          color={theme.textColors.primary}
        >
          <HoverUnderline active={isActive}>
            <span>{item.name}</span>
          </HoverUnderline>
        </Body>
        <Caret itemIsOpen={isActive} />
      </button>
    </Item>
  );
};

export default MenuItemWithDropdown;
